"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var react_perfect_scrollbar_1 = __importDefault(require("react-perfect-scrollbar"));
var store_1 = require("../../store");
var Icon_1 = __importDefault(require("../Icon"));
var Sider = antd_1.Layout.Sider;
var Guide = function (props) {
    var title = props.title, children = props.children;
    var helpAreaCollapsed = store_1.useStore(function (state) { return state.ui.helpAreaCollapsed; });
    var toggleHelpAreaCollapse = store_1.useActions(function (state) { return state.ui.toggleHelpAreaCollapse; });
    return (react_1.default.createElement(Sider, { theme: "light", collapsible: true, defaultCollapsed: true, collapsedWidth: 0, trigger: null, collapsed: helpAreaCollapsed, width: 288, className: "ant-app-helparea" },
        react_1.default.createElement("div", null,
            react_1.default.createElement(antd_1.Card, { title: title, extra: react_1.default.createElement(Icon_1.default, { name: "commons-delete_sign", onClick: toggleHelpAreaCollapse }), bordered: false },
                react_1.default.createElement(react_perfect_scrollbar_1.default, null,
                    react_1.default.createElement("div", { className: "ant-app-helparea-content" }, children))))));
};
exports.default = Guide;
